/* CupCus — trang sản phẩm:
   1) copy mã giảm giá
   2) đưa nút Size guide lên cạnh nhãn option size (dùng lại popup có sẵn của theme)
   3) gắn nhãn "Most popular" lên size bán chạy nhất
   4) rating bấm được để nhảy xuống phần review
   5) thanh mua dính đáy trên mobile
   Tất cả chạy lại được sau khi theme render lại phần variant. */
(function () {
  var POPULAR_SIZES = ['24" x 36"', '36" x 24"']; // số bán thật 60 ngày: 24x36 (39), 36x24 (22)

  /* 1) copy code ------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cc-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-cc-copy');
    var label = btn.querySelector('[data-cc-copy-label]') || btn;
    var original = label.textContent;
    var done = window.theme && theme.strings && theme.strings.offerCopied;
    function flash(text) {
      label.textContent = text;
      btn.classList.add('is-done');
      setTimeout(function () { label.textContent = original; btn.classList.remove('is-done'); }, 1800);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () { flash(done || 'Copied ✓'); })
        .catch(function () { flash('Press to copy'); });
    } else {
      var ta = document.createElement('textarea');
      ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); flash(done || 'Copied ✓'); } catch (err) { flash('Press to copy'); }
      ta.remove();
    }
  });

  /* 1b) nút áp mã một chạm: lưu mã vào giỏ + trình duyệt, không rời trang.
     Giá nút mua chỉ đổi khi mã thật sự còn trong giỏ (đọc /cart.js), không tin bộ nhớ trình duyệt. */
  var offerOn = false;
  function put(el, tx) { if (el && el.textContent !== tx) el.textContent = tx; } // chỉ ghi khi đổi: ghi trùng cũng kích lại repaint
  // giỏ đã có tranh mà đang xem tranh: thêm vào là Christmas Pair chạy, mã 20% bị thay, nên không hiện giá 20%
  function pairCart() {
    var st = document.querySelector('[data-cc-offer-state]');
    return !!document.querySelector('[data-cc-pair]') && !!st && parseInt(st.getAttribute('data-paintings') || '0', 10) >= 1;
  }
  function offerPrice(v) {       // v = tổng tiền đô; phần giảm làm tròn xuống như Shopify
    if (!offerOn || pairCart()) return v;
    var c = Math.round(v * 100);
    return (c - Math.floor(c * 0.2)) / 100;
  }
  function markApplied(btn) {
    offerOn = true;
    btn.textContent = btn.getAttribute('data-done');
    btn.classList.add('is-done');
    syncPrices();
    window.dispatchEvent(new Event('cc:offer'));
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cc-apply]');
    if (!btn || btn.classList.contains('is-done')) return;
    var code = btn.getAttribute('data-cc-apply');
    btn.disabled = true;
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' })
      .then(function () {
        try { localStorage.setItem('cc_single_code', code); } catch (err) {}
        markApplied(btn);
      })
      .catch(function () { window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(location.pathname); })
      .then(function () { btn.disabled = false; });
  });
  (function () {
    var b = document.querySelector('[data-cc-apply]');
    if (!b) return;
    var code = b.getAttribute('data-cc-apply').toUpperCase();
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var on = (c.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === code; });
      if (on) markApplied(b);
    }).catch(function () {});
  })();

  /* 2) size guide cạnh nhãn option ------------------------------------- */
  function placeSizeGuide() {
    var sg = document.querySelector('[data-cc-sg]');
    var opener = document.querySelector('.product-popup-modal__opener');
    if ((!opener && !sg) || document.querySelector('.cc-size-guide')) return;
    var legends = document.querySelectorAll('.product-form__input legend, .product-form__input .form__label, variant-swatch-king .swatch-label .swatch-option-name');
    var target = null;
    legends.forEach(function (el) {
      if (target || !el.getClientRects().length) return;      // bỏ qua nhãn đang bị ẩn
      if (/size/i.test(el.textContent || '')) target = el;
    });
    if (!target) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cc-size-guide';
    btn.textContent = (window.theme && theme.strings && theme.strings.sizeGuide) || 'Size guide';
    btn.addEventListener('click', function () {
      if (sg) { openSizeGuide(); return; }                 // bảng tự sinh
      var real = opener.querySelector('button') || opener;  // fallback: popup trang cũ
      real.click();
    });
    var head = document.createElement('div');
    head.className = 'cc-option-head';
    target.parentNode.insertBefore(head, target);
    head.appendChild(target);
    head.appendChild(btn);
    if (opener) opener.classList.add('cc-hidden'); // giữ popup cũ, chỉ ẩn nút cũ ở trên
  }

  /* 3) nhãn most popular ------------------------------------------------ */
  function markPopular() {
    // gắn nhãn thẳng lên nút (không bọc thêm khung → nút vẫn liền với ô chọn gốc, trạng thái "đang chọn" giữ đúng)
    document.querySelectorAll('.product-form__input label').forEach(function (label) {
      var text = (label.textContent || '').trim();
      if (POPULAR_SIZES.indexOf(text) === -1 || label.classList.contains('cc-pop')) return;
      label.classList.add('cc-pop');
      label.setAttribute('data-cc-badge', (window.theme && theme.strings && theme.strings.mostPopular) || 'Most popular');
    });
  }

  // nút size luôn xếp từ nhỏ tới lớn khi hiển thị (dữ liệu giữ size mặc định đứng đầu để mở trang là chọn sẵn).
  // Áp cho MỌI sản phẩm, không riêng sản phẩm đã gộp — nhãn không phải kích thước thì bỏ qua.
  function orderSizes() {
    document.querySelectorAll('variant-selects .product-form__input--block label').forEach(function (l) {
      var m = (l.textContent || '').match(/(\d+)\D+(\d+)/);
      if (m) l.style.order = String(+m[1] * +m[2]);
    });
  }

  /* 4) rating nhảy xuống review ---------------------------------------- */
  function linkRating() {
    var badge = document.querySelector('.jdgm-prev-badge, [data-cc-rating]');
    if (!badge || badge.dataset.ccBound) return;
    var target = document.querySelector('#judgeme_product_reviews, .jdgm-rev-widg, #shopify-product-reviews');
    if (!target) return;
    badge.dataset.ccBound = '1';
    badge.classList.add('cc-rating-jump');
    badge.addEventListener('click', function (e) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* 5) thanh mua dính đáy ---------------------------------------------- */
  function stickyAtc() {
    if (document.querySelector('.cc-sticky-atc')) return;
    var form = null, mainBtn = null;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      if (form) return;
      var btn = f.querySelector('[name="add"]');
      if (btn) { form = f; mainBtn = btn; }   // bỏ qua form trả góp, nó không có nút add
    });
    if (!form || !mainBtn) return;
    var priceEl = document.querySelector('.product-price-container .price-item--sale, .product-price-container .price, .price__regular');
    if (!mainBtn) return;

    var bar = document.createElement('div');
    bar.className = 'cc-sticky-atc';
    bar.innerHTML =
      '<div class="cc-sticky-atc__info"><span class="cc-sticky-atc__price" data-cc-sticky-price></span>' +
      '<small class="cc-sticky-atc__sub" data-cc-sticky-sub></small></div>' +
      '<button type="button" class="cc-sticky-atc__btn" data-cc-sticky-add>' +
      '<span class="cc-sticky-atc__label" data-cc-sticky-label></span>' +
      '</button>';
    document.body.appendChild(bar);

    var priceOut = bar.querySelector('[data-cc-sticky-price]');
    var labelOut = bar.querySelector('[data-cc-sticky-label]');
    var subOut = bar.querySelector('[data-cc-sticky-sub]');
    var addOut = bar.querySelector('[data-cc-sticky-add]');

    function currentPrice() {
      var box = document.querySelector('.product-price-container') || document;
      var el = box.querySelector('.price-item--sale, .price__sale .price-item--sale, ins .money, .price-item--regular');
      if (el && !el.closest('s, del, .price-item--regular.price--compare')) return el.textContent.trim().split('\n')[0];
      var texts = (box.innerText || '').match(/\$[\d,.]+/g) || [];
      return texts.length ? texts[texts.length - 1] : '';
    }
    function sync() {
      var lp = livePrice();
      var pair = window.ccPair && window.ccPair.open ? window.ccPair : null;
      if (pair) {                                              // đang chọn bức 2: thanh mua cả cặp
        put(priceOut, pair.total);
        put(subOut, pair.sub);
        put(labelOut, pair.label);
        addOut.disabled = pair.busy;
        toggleBar();
        return;
      }
      put(priceOut, lp ? fmt(offerPrice(lp.value + addonExtra()), lp.prefix) : currentPrice());
      put(subOut, pairCart() ? 'Christmas Pair applies in cart' : offerOn && lp ? fmt(lp.value - offerPrice(lp.value), lp.prefix) + ' off · 20% applied' : '');
      var raw = mainBtn.cloneNode(true);                       // bỏ phần giá đã chèn vào nút chính
      raw.querySelectorAll('[data-cc-btn-price]').forEach(function (n) { n.remove(); });
      put(labelOut, (raw.textContent || 'Add to cart').replace(/\s+/g, ' ').trim());
      addOut.disabled = mainBtn.disabled;
    }

    addOut.addEventListener('click', function () {
      if (window.ccPair && window.ccPair.open) window.ccPair.add(); else mainBtn.click();
    });

    function toggleBar() {
      var pairBtn = window.ccPair && window.ccPair.open ? window.ccPair.btn : null;
      var r = (pairBtn || mainBtn).getBoundingClientRect();
      var passed = pairBtn ? (r.bottom < 60 || r.top > window.innerHeight)   // mỗi lúc chỉ một nút mua
        : r.bottom < 60;                               // vừa cuộn qua nút mua chính là hiện
      var atFooter = (document.body.scrollHeight - window.scrollY - window.innerHeight) < 120;
      bar.classList.toggle('is-visible', passed && !atFooter);
    }
    window.addEventListener('scroll', toggleBar, { passive: true });
    window.addEventListener('resize', toggleBar);
    toggleBar();

    sync();
    window.addEventListener('cc:offer', sync);
    window.addEventListener('cc:pair', sync);
    window.addEventListener('cc:price', sync);
    new MutationObserver(sync).observe(form, { subtree: true, childList: true, attributes: true });
    document.addEventListener('variant:change', sync);
  }


  /* 6) đưa rating lên ngay dưới tiêu đề (theo bản phác thảo) */
  function moveRating() {
    var title = document.querySelector('.product-title-container h1, h1.product-title');
    if (!title) return;
    var badge = document.querySelector('.jdgm-widget.jdgm-preview-badge, .jdgm-preview-badge');
    if (!badge) return;
    var host = badge.closest('.shopify-block') || badge;
    if (host.dataset.ccMoved) return;
    host.dataset.ccMoved = '1';
    host.classList.add('cc-rating-row');
    title.insertAdjacentElement('afterend', host);
  }


  /* 7) giá đồng bộ mọi nơi khi đổi size ------------------------------- */
  function parseMoney(txt) {
    if (!txt) return null;
    var m = String(txt).replace(/\s/g, '').match(/([^\d]*)([\d.,]+)/);
    if (!m) return null;
    var num = m[2].replace(/,/g, '');
    var val = parseFloat(num);
    return isNaN(val) ? null : { value: val, prefix: m[1] || '$' };
  }
  function fmt(v, prefix) {
    return (prefix || '$') + v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function livePrice() {
    var box = document.querySelector('.product-price-container') || document;
    var el = box.querySelector('ins .amount') || box.querySelector('.price-item--sale') || box.querySelector('.price .amount');
    return parseMoney(el && el.textContent);
  }
  window.ccPrice = function () {   // cc-pair.js đọc giá bức đang chọn trên trang
    var p = livePrice();
    return p ? { value: p.value, prefix: p.prefix, addon: addonExtra() } : null;
  };
  var lastPriceKey = '';
  function syncPrices() {
    var p = livePrice();
    if (!p) return;

    // giá trong nút Add to cart chính
    document.querySelectorAll('form[action*="/cart/add"] [name="add"]').forEach(function (btn) {
      var span = btn.querySelector('[data-cc-btn-price]');
      if (!span) {
        span = document.createElement('span');
        span.className = 'cc-btn-price';
        span.setAttribute('data-cc-btn-price', '');
        var host = btn.querySelector('span') || btn;
        (host === btn ? btn : host.parentNode).appendChild(span);
      }
      var tx = fmt(offerPrice(p.value + addonExtra()), p.prefix);
      if (span.textContent !== tx) span.textContent = tx;     // ghi trùng cũng là thay đổi DOM, kích lại repaint
    });

    // khối offer: tính lại theo giá size đang chọn; phần giảm làm tròn xuống như Shopify
    var offer = document.querySelector('[data-cc-offer]');
    if (offer) {
      var pct = parseFloat(offer.getAttribute('data-cc-percent') || '20');
      var c = Math.round(p.value * 100);
      var off = Math.floor(c * pct / 100), half = Math.floor(c / 2);
      var afterStrong = offer.querySelector('[data-cc-offer-after] strong');
      if (afterStrong && afterStrong.textContent !== fmt(c / 100, p.prefix)) afterStrong.textContent = fmt(c / 100, p.prefix);
      var vals = { price: c, off: -off, your: c - off, two: 2 * c, half: -half, pair: 2 * c - half, pairsave: half + 2598 };
      Object.keys(vals).forEach(function (k) {
        var el = offer.querySelector('[data-o="' + k + '"]');
        var tx = (vals[k] < 0 ? '−' : '') + fmt(Math.abs(vals[k]) / 100, p.prefix);
        if (el && el.textContent !== tx) el.textContent = tx;
      });
      // chỉ báo khi giá thật sự đổi: báo mỗi lần repaint thì ô chọn bức 2 vẽ lại liên tục, khách chạm trên điện thoại bị mất (3/11/2026)
      var key = p.value + '|' + offerOn + '|' + addonExtra() + '|' + pairCart();
      if (key !== lastPriceKey) { lastPriceKey = key; window.dispatchEvent(new Event('cc:price')); }
    }
  }


  /* 7) Stretched / Framed + màu khung; đổi bộ ảnh theo Style ------------ */
  var galleryCache = {};
  function swapGallery(v) {
    var g = document.querySelector('[data-cc-group]');
    if (!g) return;
    // Bức còn trục thứ hai (Shape): khoá gallery ghép "Style / Hướng" — data-cc-axis là vị trí option đó
    var ax = parseInt(g.dataset.ccAxis || '0', 10);
    var key = ax ? v.option1 + ' / ' + v['option' + ax] : v.option1;
    if (g.dataset.ccGroup === key) return;
    var id = g.id;
    g.dataset.ccWant = key;
    g.classList.add('is-cc-swapping');
    var url = location.pathname + '?variant=' + v.id + '&section_id=' + id.replace('MediaGallery-', '');
    if (!galleryCache[key]) galleryCache[key] = fetch(url).then(function (r) { return r.text(); });
    galleryCache[key].then(function (html) {
      var cur = document.getElementById(id);
      if (!cur || cur.dataset.ccWant !== key) return;          // khách đã bấm lựa chọn khác
      var src = new DOMParser().parseFromString(html, 'text/html').getElementById(id);
      if (src) { cur.innerHTML = src.innerHTML; cur.dataset.ccGroup = src.dataset.ccGroup; }
      cur.classList.remove('is-cc-swapping');
    }).catch(function () { delete galleryCache[key]; g.classList.remove('is-cc-swapping'); });
  }

  function styleTiles() {
    var root = document.querySelector('[data-cc-style]');
    // Sản phẩm không có option Style (chỉ Shape + Size) nhưng có bộ ảnh theo khổ: vẫn đổi gallery khi đổi variant
    var gal = document.querySelector('[data-cc-group]');
    if (!root && gal && !gal.dataset.ccSwapBound) {
      gal.dataset.ccSwapBound = '1';
      document.addEventListener('product:variant-change', function (e) {
        var v = e.detail && e.detail.variant;
        if (v) swapGallery(v);
      });
    }
    if (!root || root.dataset.ccReady) return;
    root.dataset.ccReady = '1';
    var on = root.querySelector('[data-cc-frame][aria-pressed="true"]');
    var lastFrame = on ? on.dataset.ccFrame : 'Black Frame';

    function choose(val) {
      var r = document.querySelector('.cc-native-style input[value="' + val + '"]');
      if (!r || r.checked) return;
      r.checked = true;
      r.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function paint(style) {
      var framed = style !== 'Stretched Canvas';
      root.querySelectorAll('[data-cc-kind]').forEach(function (b) {
        b.setAttribute('aria-pressed', String((b.dataset.ccKind === 'framed') === framed));
      });
      root.querySelector('[data-cc-frames]').hidden = !framed;
      root.querySelector('[data-cc-what-stretched]').hidden = framed;
      root.querySelector('[data-cc-what-framed]').hidden = !framed;
      root.querySelectorAll('[data-cc-frame]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(framed && b.dataset.ccFrame === style));
      });
      if (framed) root.querySelector('[data-cc-frame-name]').textContent = style;
    }
    root.addEventListener('click', function (e) {
      var k = e.target.closest('[data-cc-kind]'), f = e.target.closest('[data-cc-frame]');
      if (k) choose(k.dataset.ccKind === 'stretched' ? 'Stretched Canvas' : lastFrame);
      if (f) { lastFrame = f.dataset.ccFrame; choose(lastFrame); }
    });
    document.addEventListener('product:variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      paint(v.option1);
      swapGallery(v);
    });
  }

  /* 8) Ô tick bán kèm (Premium Canvas) ---------------------------------- */
  function sizeKey(txt) {                       // '24" x 36"' / '36x24' → '24x36'
    var m = String(txt || '').match(/(\d+)\D+(\d+)/);
    if (!m) return '';
    var a = +m[1], b = +m[2];
    return Math.min(a, b) + 'x' + Math.max(a, b);
  }
  function currentSize() {
    var found = '';
    document.querySelectorAll('variant-selects input:checked, variant-selects select, variant-radios input:checked').forEach(function (el) {
      if (!found && /\d+\s*"?\s*x\s*\d+/i.test(el.value)) found = el.value;
    });
    if (found) return found;
    // app ẩn ô chọn của theme → lấy size từ chính variant đang chọn
    try {
      var form = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var data = document.querySelector('variant-selects [type="application/json"]');
      if (!form || !data) return '';
      var id = parseInt(form.value, 10);
      var v = JSON.parse(data.textContent).filter(function (x) { return x.id === id; })[0];
      if (!v) return '';
      for (var i = 0; i < v.options.length; i++) {
        if (/\d+\s*"?\s*x\s*\d+/i.test(v.options[i])) return v.options[i];
      }
    } catch (e) {}
    return '';
  }
  function addonState() {
    var box = document.querySelector('[data-cc-addon]');
    if (!box) return null;
    var large = (box.dataset.large || '').split(',').map(sizeKey);
    var isLarge = large.indexOf(sizeKey(currentSize())) > -1;
    return {
      box: box,
      checked: box.querySelector('[data-cc-addon-check]').checked,
      id: isLarge ? box.dataset.largeId : box.dataset.smallId,
      price: +(isLarge ? box.dataset.largePrice : box.dataset.smallPrice) / 100
    };
  }
  window.ccAddonFor = function (txt) {   // cc-pair.js: giá và variant Premium theo size bức 2
    var box = document.querySelector('[data-cc-addon]');
    if (!box) return null;
    var large = (box.dataset.large || '').split(',').map(sizeKey).indexOf(sizeKey(txt)) > -1;
    return { id: +(large ? box.dataset.largeId : box.dataset.smallId), price: +(large ? box.dataset.largePrice : box.dataset.smallPrice), material: box.dataset.material };
  };
  function addonExtra() { var s = addonState(); return s && s.checked ? s.price : 0; }
  function paintAddon() {
    var s = addonState();
    if (!s) return;
    var p = livePrice();
    put(s.box.querySelector('[data-cc-addon-price]'), '+' + fmt(s.price, p ? p.prefix : '$'));
    s.box.classList.toggle('is-checked', s.checked);
  }
  // product.min.js gọi hàm này khi bấm mua: có tick → gửi 2 món cùng lúc
  window.ccAddonItems = function (form) {
    var s = addonState();
    if (!s || !s.checked) return null;
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    var q = qty ? parseInt(qty.value, 10) || 1 : 1;
    var link = Date.now().toString(36);
    var title = (document.querySelector('h1.product-title') || {}).textContent || '';
    var props = { _cc_link: link };
    props[s.box.dataset.material ? 'Material' : 'Upgrade'] = s.box.dataset.material || 'Yes';
    // món kèm gửi trước → giỏ hiện tranh ở trên, dòng nâng cấp ngay dưới (Shopify xếp món mới nhất lên đầu)
    return [
      { id: +s.id, quantity: q, properties: { For: title.trim() + ' (' + currentSize().replace(/"/g, '″') + ')', _cc_link: link } },
      { id: +id.value, quantity: q, properties: props }
    ];
  };
  document.addEventListener('change', function (e) {
    if (!e.target.closest('[data-cc-addon-check]')) return;
    paintAddon();
    syncPrices();
    document.dispatchEvent(new CustomEvent('variant:change'));   // nút dính đáy cập nhật giá
  });

  /* 9) Ẩn dòng "How we use your data…" trong form Judge.me (form cũ để đoạn này KHÔNG có class) */
  function hideJmNotice() {
    var host = document.querySelector('.jdgm-widget, #judgeme_product_reviews, .jdgm-write-review-modal, dialog');
    if (!host) return;
    document.querySelectorAll('.jdgm-form p, .jdgm-qna-form p, [class*="jdgm"] p, dialog p').forEach(function (p) {
      if (!/how we use your data/i.test(p.textContent || '')) return;
      var box = p.closest('.jdgm-form__fieldset') || p.parentElement || p;
      box.style.display = 'none';
    });
  }
  var jmNoticeTimer = null;
  function watchJmNotice() {
    if (!document.querySelector('[class*="jdgm"]')) return;
    hideJmNotice();
    new MutationObserver(function () {
      clearTimeout(jmNoticeTimer);
      jmNoticeTimer = setTimeout(hideJmNotice, 120);
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      if (e.target.closest('.jdgm-write-rev-link, .jdgm-ask-question-btn')) setTimeout(hideJmNotice, 400);
    });
  }

  /* 10) Size guide tự sinh: hình vẽ đổi theo size đang chọn, bấm 1 dòng là chọn size đó */
  function sizeRows() { return Array.prototype.slice.call(document.querySelectorAll('[data-cc-sg-row]')); }
  function drawSizeGuide() {
    var box = document.querySelector('[data-cc-sg]');
    if (!box) return;
    sizeRows().forEach(function (r) { r.style.order = String(+r.dataset.w * +r.dataset.h); });  // nhỏ → lớn
    var size = sizeKey(currentSize());                       // '24x36' (nhỏ x lớn)
    var row = sizeRows().filter(function (r) {
      return sizeKey(r.dataset.w + 'x' + r.dataset.h) === size;
    })[0] || sizeRows()[0];
    if (!row) return;
    sizeRows().forEach(function (r) { r.classList.toggle('is-current', r === row); });
    var w = +row.dataset.w, h = +row.dataset.h;
    if (box.dataset.drawn === size) return;                  // đã vẽ size này rồi: vẽ lại cũng kích repaint
    box.dataset.drawn = size;
    var art = box.querySelector('[data-cc-sg-art]');
    art.setAttribute('width', w);
    art.setAttribute('height', h);
    art.setAttribute('x', String(50 - w / 2));               // canh giữa sofa (sofa 8→92)
    art.setAttribute('y', String(76 - 9 - h));               // mép dưới cách lưng sofa 9 inch
    box.querySelector('[data-cc-sg-current]').innerHTML = '<b>' + row.querySelector('.cc-sg__size').textContent + '</b>';
    box.querySelector('[data-cc-sg-hint]').textContent = row.dataset.hint || '';
  }
  function openSizeGuide() {
    var box = document.querySelector('[data-cc-sg]');
    if (!box) return;
    drawSizeGuide();
    box.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }
  function closeSizeGuide() {
    var box = document.querySelector('[data-cc-sg]');
    if (!box) return;
    box.hidden = true;
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cc-sg-close]')) { closeSizeGuide(); return; }
    var row = e.target.closest('[data-cc-sg-row]');
    if (!row) return;
    var want = sizeKey(row.dataset.w + 'x' + row.dataset.h);
    document.querySelectorAll('variant-selects label, variant-swatch-king .swatch-view-item').forEach(function (l) {
      if (sizeKey(l.textContent) === want) l.click();        // chọn đúng nút size (theme hoặc app)
    });
    setTimeout(drawSizeGuide, 60);       // giữ bảng mở để khách so sánh tiếp
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSizeGuide(); });

  function init() { watchJmNotice(); styleTiles(); paintAddon(); orderSizes(); placeSizeGuide(); markPopular(); linkRating(); stickyAtc(); moveRating(); syncPrices(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // theme render lại variant sau khi đổi lựa chọn
  // trang luôn có phần tử đang chạy (~14 thay đổi/giây) nên chỉ chờ "yên" là bị hoãn mãi: chờ tối đa 400ms;
  // số tranh trong giỏ đổi thì cập nhật giá ngay
  var repaint = (function () {
    var t = null, first = 0, lastN = null;
    function run() { t = null; first = 0; markPopular(); paintAddon(); syncPrices(); drawSizeGuide(); }
    return function () {
      var st = document.querySelector('[data-cc-offer-state]'), n = st ? st.getAttribute('data-paintings') : null;
      if (n !== lastN) { lastN = n; clearTimeout(t); run(); return; }
      var now = Date.now(); if (!first) first = now;
      clearTimeout(t); t = setTimeout(run, now - first > 280 ? 0 : 120);
    };
  })();
  new MutationObserver(repaint).observe(document.documentElement, { subtree: true, childList: true, characterData: true });
  document.addEventListener('variant:change', repaint);
  document.addEventListener('click', function (e) { if (e.target.closest('.swatches, .product-form__input, [data-cc-offer]')) repaint(); });
  setTimeout(init, 1500);
  setTimeout(function(){ linkRating(); moveRating(); }, 3500);
})();
